var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1639_3118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5C9 8.29565 9.31607 9.05871 9.87868 9.62132C10.4413 10.1839 11.2044 10.5 12 10.5C12.7956 10.5 13.5587 10.1839 14.1213 9.62132C14.6839 9.05871 15 8.29565 15 7.5C15 6.70435 14.6839 5.94129 14.1213 5.37868C13.5587 4.81607 12.7956 4.5 12 4.5C11.2044 4.5 10.4413 4.81607 9.87868 5.37868C9.31607 5.94129 9 6.70435 9 7.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75C13.7902 0.75 15.5071 1.46116 16.773 2.72703C18.0388 3.9929 18.75 5.70979 18.75 7.5C18.75 10.751 13.618 18.027 12.304 19.837C12.269 19.8847 12.2232 19.9236 12.1704 19.9503C12.1176 19.9771 12.0592 19.991 12 19.991C11.9408 19.991 11.8824 19.9771 11.8296 19.9503C11.7768 19.9236 11.731 19.8847 11.696 19.837C10.382 18.027 5.25 10.751 5.25 7.5C5.25 5.70979 5.96116 3.9929 7.22703 2.72703C8.4929 1.46116 10.2098 0.75 12 0.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.979 17.7842C20.711 18.3252 22.5 19.2282 22.5 20.2502C22.5 21.9072 17.8 23.2502 12 23.2502C6.2 23.2502 1.5 21.9072 1.5 20.2502C1.5 19.2302 3.281 18.3292 6 17.7872",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1639_3118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.5405e28e9d5e66654c1e0b525f08b51b.svg";
export { ForwardRef as ReactComponent };